<script>
export default {
    name: "section",

    props: 
    {
        fluid: Boolean,
        backgroundImage: String,
        backgroundColor: String,
        overlay: Boolean,
        isPattern: Boolean,
        noPad: Boolean,
    },

    computed:
    {
        backgroundImageUrl()
        {
            return `url(${this.backgroundImage})`
        }
    },

    render(h)
    {
        return h(
            'section',
            {
                class: [
                    'justfit-section', this.isPattern ? 'repeat-bg' : 'cover-bg'
                ],
                style: {
                    backgroundImage: this.backgroundImage ? this.backgroundImageUrl : null,
                    backgroundColor: this.backgroundColor
                }
            },
            [
                this.overlay ? h(
                    'div',
                    { class: ['section-overlay'] }
                ) : null,
                h(
                    'div',
                    {
                        class: [
                            {
                                'container': !this.fluid,
                                'container-fluid': this.fluid,
                                'p-0': this.noPad
                            },
                            'section-content'
                        ]
                    },
                    this.$slots.default
                )
            ]
        )
    }
}
</script>
